﻿import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router } from "@angular/router";
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../_services';


@Component({
    selector: 'login',
    templateUrl: './login.component.html'
})



export class LoginComponent {

    accessTokenObj: any;
    isLoggedin: any;

    public loginForm: FormGroup;
    model: any = {};

    constructor(
        private http: HttpClient, private router: Router,
        private formBuilder: FormBuilder,
        private authService: AuthService
    ) {
        this.router.navigate(['/home']);
    }

    onLoginSubmit() {
        this.authService.login();
    }

    onLogout() {
        this.authService.logout();
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('id_token');
        localStorage.removeItem('auth0profile');

        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('companyId');
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        window.location.reload();
        this.router.navigate(['/home']);
    }
}

